import { useTranslation } from "react-i18next";
import helpers from "../../../../Utils/helpers";
import ExpandableTable from "../../../Fundamentals/Tables/ExpandedableTable";
import { Button, ButtonOption } from "../../../Fundamentals/Button";
import useUserAccess from "../../../../Hooks/useUserAccess";
import {UserRoles} from "../../../../Constants/userRoles";

const InactiveSubscriptions = ({ subscriptions, detailedSubscriptions, fetchDetailedSubscription, onReactivate }) => {
    const { t } = useTranslation();
    const { hasAdminAccess } = useUserAccess();

    const onClick = (subscription) => {
        fetchDetailedSubscription(subscription);
    };
    
    return (
        <ExpandableTable>
            <thead>
                <tr>
                    <th className="text-left">{t('common.package')}</th>
                    <th className="text-left">{t('common.tier')}</th>
                    <th className="text-left">{t('common.purchasedate')}</th>
                    <th className="text-left">{t('common.enddate')}</th>
                    {hasAdminAccess(UserRoles.SubscriptionAdmin) &&
                    <th className="text-center">{t('reactivateSubscription.reactivate')}</th>}
                </tr>
            </thead>
            <ExpandableTable.Body>
                {subscriptions?.map(subscription => (
                    <ExpandableTable.Row key={subscription.id}>
                        <ExpandableTable.Row.Expandable onClick={() => onClick(subscription)}>
                            <td>{subscription?.package.name}</td>
                            <td>{subscription?.tier.name}</td>
                            <td>{helpers.formatDate(subscription?.created)}</td>
                            <td>{helpers.formatDate(subscription?.termination.scheduledDate)}</td>
                            {hasAdminAccess(UserRoles.SubscriptionAdmin) && 
                                <td className="text-center">
                                    <Button
                                        option={ButtonOption.PRIMARY}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            onReactivate(subscription);
                                        }}
                                    >
                                        {t('reactivateSubscription.reactivate')}
                                    </Button>
                                </td>}
                        </ExpandableTable.Row.Expandable>
                        <ExpandableTable.Row.Expanded>
                            <tr>
                                <td colSpan={100}>
                                    {detailedSubscriptions[subscription.id]?.termination?.reason ? (
                                        <div className="d-flex flex-column gap-12 my-12">
                                            <p className="m-0">
                                                <span className="bold">{t('inactiveSubscriptions.terminationReason')}</span> {detailedSubscriptions[subscription.id]?.termination?.reason?.reasonName}
                                            </p>
                                            {detailedSubscriptions[subscription.id]?.termination?.reason?.subReasonName && (
                                                <p className="m-0">
                                                    <span className="bold">{t('inactiveSubscriptions.subReason')}</span> {detailedSubscriptions[subscription.id]?.termination?.reason?.subReasonName}
                                                </p>
                                            )}
                                            <p className="m-0">
                                                <span className="bold">{t('inactiveSubscriptions.comment')}</span> {detailedSubscriptions[subscription.id]?.termination?.reason?.comment?.trim() || <em>{"N/A"}</em>}
                                            </p>
                                        </div>
                                    ) : (
                                        <p className="m-0 my-12">
                                            <span className="bold">{t('inactiveSubscriptions.terminationReason')}</span> {"N/A"}
                                        </p>
                                    )}
                                </td>
                            </tr>
                        </ExpandableTable.Row.Expanded>
                    </ExpandableTable.Row>
                ))}
            </ExpandableTable.Body>
        </ExpandableTable>
    )
}

export default InactiveSubscriptions;
